import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import leafIcon from "../../../assets/icons/leaf-icon.svg";
import lockIcon from "../../../assets/icons/lock-icon.png";
import targetIcon from "../../../assets/icons/target-icon.png";
import forwardArrow from "../../../assets/icons/forward-arrow.svg";
import FeatureCard from "./FeatureCard";
import Testimonial from "./Testimonial";
import RegisterYourInterest from "./RegisterYourInterest";
import { useContentfulContext } from "../../../contexts/ContentfulContext";

const PWD_REGEX = /^.{8,}$/;
const EMAIL_REGEX = /\S+@\S+\.\S+/;

const Home = () => {
  
  const { content } = useContentfulContext();
  const { loginWithRedirect } = useAuth0();
  const [searchParams] = useSearchParams();

  const [email] = useState("");
  const [, setValidEmail] = useState(false);

  const [pwd] = useState("");
  const [, setValidPwd] = useState(false);

  useEffect(() => {
    if (searchParams.get("organization")) {
      loginWithRedirect({
        authorizationParams: {
          redirect_uri: process.env.REACT_APP_AUTH0_BASE_URL,
          is_invited: true,
          email: searchParams.get("email"),
          role_id: searchParams.get("role_id"),
          organization_id: searchParams.get("organization"),
          organization_name: searchParams.get("organization_name"),
          invitation_id: searchParams.get("invitation"),
        },
      });
    }
  }, []);

  useEffect(() => {
    const result = EMAIL_REGEX.test(email);
    setValidEmail(result);
  }, [email]);

  useEffect(() => {
    const result = PWD_REGEX.test(pwd);
    setValidPwd(result);
  }, [pwd]);

  // function formSubmitHandler() {
    // e.preventDefault();
    // if (!validEmail || !validPwd) {
    //   var result = EMAIL_REGEX.test(email);
    //   setValidEmail(result);
    //   console.log(result)

    //   var result = PWD_REGEX.test(pwd);
    //   setValidPwd(result);
    //   return;
    // }

    // setAuth({
    //   user_name: "",
    //   user_email: "",
    //   user_verification: false,
    //   user_loggedIn: true,
    // });
    // window.localStorage.setItem("logged-in", true);
    // navigate("/dashboard");

    // var myHeaders = new Headers();
    // myHeaders.append("Content-Type", "text/plain");

    // const formData = {
    //   'user_email': email,
    //   'user_password': pwd
    // };

    // var requestOptions = {
    //   method: 'POST',
    //   headers: myHeaders,
    //   body: JSON.stringify(formData),
    //   redirect: 'follow',
    // };

    // fetch("https://script.google.com/macros/s/AKfycby2eMtl_nydI3X-gCF0c5bzfD_27ARJ2LeeGF26d_1fbjb-EpGAR7Frlv6zY0qGWDap/exec?action=getUserId", requestOptions)
    //   .then(response => response.json())
    //   .then(result => {
    //     if (result.status_code == 300) {
    //       alert('user with this email does not exits');
    //     } else {
    //       const authData = {
    //         user_name: 'test',
    //         user_email: email,
    //         user_verification: false,
    //         user_loggedIn: true
    //       }
    //       setAuth(authData);
    //       localStorage.setItem('user_internal_id', result.user_internal_id);
    //       navigate('/account');
    //     }
    //   })
    //   .catch(error => console.log('error', error));
  // }

  // const responseGoogle = (response) => {
  //   console.log(response, ">>>>");
  //   const userObject = jwt_decode(response.credential);
  //   localStorage.setItem("user", JSON.stringify(userObject));
  //   const { name, sub, picture } = userObject;
  //   const doc = {
  //     _id: sub,
  //     _type: "user",
  //     userName: name,
  //     image: picture,
  //   };
  //   // client.createIfNotExists(doc).then(() => {
  //   //   navigate('/', { replace: true });
  //   // });
  // };

  const MeetTheDemand = [
    {
      id: 1,
      title: "Ease of use",
      description: "Ease: Simplifying Experience Creation",
      icon: <img src={leafIcon} alt="leafIcon" />,
    },
    {
      id: 2,
      title: "Goal setting and tracking",
      description: "Set and track goals with manageable task breakdowns.",
      icon: <img src={targetIcon} alt="targetIcon" />,
    },
    {
      id: 3,
      title: "Secure data encryption",
      description: "Ensure your data's safety with top-tier encryption.",
      icon: <img src={lockIcon} alt="lockIcon" />,
    },
  ];

  const PersonalizationMadeEasy = {
    subtitle: "Ease of Use",
    title: "Simplifying Experience Creation",
    description:
      "Stride simplifies experience creation by allowing marketers to easily update experiences using pre-built templates, intuitive form inputs, instantly see changes with real-time previews, and preview how experiences will appear across different devices with mobile simulation.",
    featuredTitle: "Personalisation Made Easy",
    features: [
      {
        id: 1,
        title: "Form-Based Updates",
        description: "Easily update experiences using intuitive form inputs.",
      },
      {
        id: 2,
        title: "Real-Time Previews",
        description: "Instantly see changes as you make them",
      },
      {
        id: 3,
        title: "Mobile Simulation",
        description:
          "Preview how experiences will appear across different devices.",
      },
    ],
  };

  const ConfidenceInDelivery = {
    subtitle: "Experiment with Confidence",
    title: "Ensuring Error-Free Personalisation",
    description:
      "Stride ensures error-free personalisation by applying business rules like mandatory fields and input lengths to avoid mistakes, providing real-time error alerts to ensure accuracy, and eliminating the complexity and risk of working with JSON objects",
    featuredTitle: "Confidence in Delivery",
    features: [
      {
        id: 1,
        title: "Form-Based Updates",
        description: "Easily update experiences using intuitive form inputs.",
      },
      {
        id: 2,
        title: "Real-Time Previews: ",
        description: "Instantly see changes as you make them",
      },
      {
        id: 3,
        title: "Mobile Simulation: ",
        description:
          "Preview how experiences will appear across different devices.",
      },
    ],
  };

  const EfficiencyInExecution = {
    subtitle: "Efficiency in Execution",
    title: "Saving Time Through Automation",
    description:
      "Stride saves time through automation by seamlessly integrating with Adobe Target, allowing marketers to quickly deploy new experiences with a single click, and eliminating the need for manual updates and copy-pasting.",
    featuredTitle: "Efficiency \n in Execution",
    features: [
      {
        id: 1,
        title: "Form-Based Updates",
        description: "Easily update experiences using intuitive form inputs.",
      },
      {
        id: 2,
        title: "Real-Time Previews: ",
        description: "Instantly see changes as you make them",
      },
      {
        id: 3,
        title: "Mobile Simulation: ",
        description:
          "Preview how experiences will appear across different devices.",
      },
    ],
  };

  const handleLogin = () => {
    loginWithRedirect({
      authorizationParams: {
        redirect_uri: process.env.REACT_APP_AUTH0_BASE_URL,
      },
    });
  };

  return (
    <div className="popins-fonts">
        <section className="py-24 bg-gradient-to-tl from-[#5575BF78] to-[#465DAE] min-h-screen">
        <div className="w-full">
          <div className="flex justify-between items-start">
            <div className="lg:pl-48 pl-5">
              <h1 className="mb-4 text-7xl font-semibold text-gray-900">
                <span className="">
                  Accelerate <br />
                </span>
                <span className="">Your Experience Optimisation</span>
              </h1>
              <p className="font-normal text-lg">
                {content.LOGIN_CONTENT?.hero_section.description}
              </p>
              <p className="font-normal text-lg">
                {content.LOGIN_CONTENT?.hero_section.short_description}
              </p>
              <div className="mt-10 flex gap-8">
                <button onClick={handleLogin} className="bg-white text-primary py-3 rounded-2xl text-xl px-12">
                  Login
                </button>
                <button onClick={handleLogin} className="py-3 rounded-2xl px-12 border border-white text-xl text-white ">
                  Register
                </button>
              </div>
            </div>
            <div className="h-full w-full">
              <div className="--[724px] object-cover">
                <img
                  src={content.LOGIN_CONTENT?.hero_section.image_url}
                  className="h-full"
                  alt="Sample"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="bg-gradient-to-t from-[#c8d3fa] via-white to-white">
        <section className="px-4 py-24 mx-auto container">
          <div className="w-full mx-auto md:w-11/12 xl:w-9/12 text-center">
            <div className="flex justify-center items-center mb-5">
              <p className="text-sm font-medium border px-2 max-w-60 rounded-xl py-1">
                Personalisation made easier
              </p>
            </div>
            <h1 className="mb-6 text-[50px] font-bold leading-none tracking-normal text-gray-900 md:text-6xl md:tracking-tight">
              Meet The Demand <br />
              For Personalisation
            </h1>
            <p className="px-0 mb-6 text-lg text-gray-600 md:text-2xl lg:px-24">
              Created by experienced marketers, Stride simplifies the process of
              personalisation, making it accessible and manageable for marketing
              teams of all sizes.
            </p>
          </div>
          <div className="w-full mx-auto mt-20 text-center md:w-11/12">
            <img
              src="https://dazetta.co/wp-content/uploads/2024/06/Stride_HomepageBanner.png"
              alt="Hellonext feedback boards software screenshot"
              className="w-full rounded-lg shadow-2xl"
            />
          </div>
        </section>
        <section className="max-w-7xl mx-auto py-24 px-5">
          <div className="grid grid-cols-3">
            {MeetTheDemand.map((meet) => (
              <div className="flex flex-col gap-2 items-start" key={meet.id}>
                <div className="h-6 w-6 font-bold">{meet.icon}</div>
                <h2 className="text-lg font-bold">{meet.title}</h2>
                <p className="font-normal">{meet.description}</p>
                <button className="flex items-center">
                  Learn more{" "}
                  <img
                    src={forwardArrow}
                    alt="forwardArrow"
                    className="h-5 w-5"
                  />{" "}
                </button>
              </div>
            ))}
          </div>
        </section>
      </div>
      <section className="px-4 mt-28 max-w-screen-xl mx-auto">
        <div className="w-full mx-auto md:w-11/12 xl:w-9/12 text-center">
          <div className="flex justify-center items-center mb-5">
            <p className="text-sm font-medium border px-2 max-w-xs w-full rounded-xl py-1">
              Experience optimisation made effortless
            </p>
          </div>
          <h1 className="mb-6 text-[50px] font-bold leading-none tracking-normal text-gray-900 md:text-6xl md:tracking-tight">
            Built by Marketers, for Marketers
          </h1>
          <p className="px-0 mb-6 text-lg text-gray-600 md:text-2xl lg:px-24">
            Stride makes personalization easy, confident, and efficient,
            enabling marketers to deliver the engaging experiences that
            today&apos;s consumers expect. Experience creation has never been
            this simple.
          </p>
        </div>
      </section>
      <div className="px-4 py-24 max-w-screen-xl mx-auto">
        <FeatureCard featuredCardData={PersonalizationMadeEasy} />
      </div>
      <div className="bg-gradient-to-t from-[#D2DCFF] to-[#D2DCFF]">
        <div className="px-4 py-24 max-w-screen-xl mx-auto">
          <FeatureCard featuredCardData={ConfidenceInDelivery} />
        </div>
      </div>
      <div className="px-4 pt-24 pb-10 max-w-screen-xl mx-auto">
        <FeatureCard featuredCardData={EfficiencyInExecution} />
      </div>
      <div className="mb-14">
        <div className=" flex justify-center items-center">
          <button className="bg-[#1138A5] text-white text-xl font-medium px-10 py-3 rounded-2xl">
            Register Interest
          </button>
        </div>
      </div>
      <div className="">
        <Testimonial />
      </div>
      <div className=" my-28">
        <RegisterYourInterest />
      </div>
      {/* <GoogleOAuthProvider clientId="283521836355-rr6u6ehak55egeom9f31a2o4vrf4l6at.apps.googleusercontent.com">
                <GoogleLogin
                  render={(renderProps) => (
                    <button
                      type="button"
                      className=""
                      onClick={renderProps.onClick}
                      disabled={renderProps.disabled}
                    >
                      Sign in with google
                    </button>
                  )}
                  onSuccess={responseGoogle}
                  onFailure={responseGoogle}
                  cookiePolicy="single_host_origin"
                />
              </GoogleOAuthProvider> */}
    </div>
  );
};

export default Home;
